(function() {
    'use strict';

    angular
        .module('app')
        .directive('enterSearch', directive);

    directive.$inject = ['$window'];
    
    function directive ($window) {
        // Usage:
        //     <directive></directive>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                callBack: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            element.bind('keydown keypress', function (e) {
                if (e.keyCode == 13) {
                    scope.callBack();
                    e.preventDefault();
                }
            })
        }
    }

})();